<div class="mc-shell"
  [style.--mc-bg]="bgColor || null"
  [style.--mc-fg]="fgColor || null"
  [style.--mc-icon]="iconColor || null">
  <div class="mc-header">
    <div class="mc-title-group">
      @if (icon) {
        <generic-icon [iconName]="icon" [type]="type" class="mc-title-icon"></generic-icon>
      }
      <span class="mc-title">{{ title }}</span>
    </div>

    <button nz-button nzType="text" nzShape="circle" *ngIf="showConfiguration"
      nz-dropdown [nzDropdownMenu]="menu" nzTrigger="click">
      <span nz-icon nzType="more"></span>
    </button>

    <nz-dropdown-menu #menu="nzDropdownMenu">
      <ul nz-menu>
        <li nz-menu-item (click)="openConfiguration()">
          <span nz-icon nzType="setting" class="mc-menu-icon"></span>
          <span>Configurações</span>
        </li>
        <li nz-menu-item nzDanger (click)="excluir()">
          <span nz-icon nzType="delete" class="mc-menu-icon"></span>
          <span>Excluir</span>
        </li>
      </ul>
    </nz-dropdown-menu>
  </div>

  <nz-spin class="mc-spin" [nzSpinning]="loading">
    <div class="mc-body">
      <div class="mc-content">
        <h2 class="mc-value" *ngIf="isCurrency">{{ value | currency:'$':'symbol':'0.0' }}</h2>
        <h2 class="mc-value" *ngIf="!isCurrency">{{ value }}</h2>
      </div>

      <div class="mc-metrics">
        <span class="mc-delta" [ngClass]="{ 'up': isIncrease, 'down': !isIncrease }">
          {{ isIncrease ? '+' : '-' }}
          <span *ngIf="percentValue">{{ percentValue | percent:'2.1-2' }}</span>
          <span nz-icon [nzType]="isIncrease ? 'arrow-up' : 'arrow-down'"></span>
        </span>
        <span class="mc-duration">{{ duration }}</span>
      </div>
    </div>
  </nz-spin>

  <div class="mc-footer" *ngIf="item.refresh != null && item.refresh > 0">
    <span class="mc-last-update">
      <span nz-icon nzType="clock-circle" class="mc-last-update-icon"></span>
      Última Atualização: {{ lastUpdate }}
    </span>
  </div>
</div>
